import { z } from "zod";

export const backofficeUnauthorizedResponseSchema = z.object({
  error: z.literal("unauthorized"),
  error_description: z.string(),
});

export const backofficeErrorSchema = z.object({
  code: z.string().nullable(),
  error: z.string().nullish(),
  message: z.string().nullish(),
  messageCode: z.string().nullish(),
  error_description: z.string().nullish(),
  data: z.any().nullish(),
  params: z.array(z.any()).nullish(),
});
